import WishlistButton from './frontoffice/WishlistButton';
customElements.define('wishlist-button', WishlistButton, {extends: 'a'});

import ProductImagePhotoswipe from './frontoffice/ProductImagePhotoswipe';
customElements.define('product-image-photoswipe', ProductImagePhotoswipe,{extends: 'div'});

import YoutubeLink from './frontoffice/YoutubeLink';
customElements.define('youtube-link', YoutubeLink,{extends: 'a'});

import SingleFilter from "./frontoffice/Filters/SingleFilter";
customElements.define('single-filter', SingleFilter, {extends: 'div'});

import FilterTag from "./frontoffice/Filters/FilterTag";
customElements.define('filter-tag', FilterTag, {extends: 'div'});

import SearchProducts from "./frontoffice/SearchProducts";
customElements.define('search-products', SearchProducts, {extends: 'div'});
